import React, { useState } from 'react';
import StarRatings from 'react-star-ratings';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import { rateTaskRequest } from '@core/api/task/task.service';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid2';
import {
  Box, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Tooltip, TextField, IconButton
} from '@mui/material';
import { FielderButton } from 'OldComponents/ui';
import CloseIcon from '@mui/icons-material/Close';
import { SmartTitleTypography } from '~/FielderElements/SmartTaskTable/SmartStyles';

const RateTask = (props) => {
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState('');
  const [descError, setDescError] = useState(false);
  const handleClose = () => {
    if (props.closeErrorMessage) props.closeErrorMessage();
    if (props.onClose) props.onClose();
  };
  const handleRateTask = () => {
    if (!description || description.trim() === '') {
      setDescError(true);
      return;
    }
    const idTasks = props.idTasks?.[0];
    const body = {
      ratingObject: {
        rating,
        comment: description,
        idTask: idTasks,
        idUser: props.user.idUser,
        idAccount: props.user.idAccount,
      },
    };
    const loadingConfig = { dispatch: props.dispatch };
    const onSuccess = props.onCloseModalSuccess;
    const onError = props.onCloseModalError;
    rateTaskRequest(body, onSuccess, onError, loadingConfig);
  };
  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      {/* Header */}
      <DialogTitle>
        <Grid container>
          <Grid size={6}>
            <SmartTitleTypography variant='subtitle1'>
              {props.lan.rateTask}
            </SmartTitleTypography>
          </Grid>
          <Grid size={6}>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <IconButton id={'close-modal-button'} aria-label="close" onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      {/* Body */}
      <DialogContent>
        <Grid container spacing={2} sx={{ p: 1 }}>
          {/* Stars */}
          <Tooltip arrow title={props.lan.rateTooltipText} placement="top">
            <Grid size={12} sx={{ mt: 2 }}>
              <StarRatings
                rating={rating}
                starRatedColor="yellow"
                starHoverColor="yellow"
                changeRating={(newRating) => setRating(newRating)}
                numberOfStars={5}
                name="rating"
              />
            </Grid>
          </Tooltip>
          {/* Comment input + red alert icon (kept visually similar) */}
          <Grid size={12} sx={{ position: 'relative', mt: 1 }}>
            <TextField
              id="description-red-input"
              placeholder={props.lan.clientComment}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                if (descError && e.target.value.trim() !== '') setDescError(false);
              }}
              multiline
              fullWidth
              rows={3}
              slotProps={{
                input: {
                  maxLength: 255,
                },
              }}
              error={descError}
              helperText={descError ? props.lan.requiredFields || props.lan.required : ''}
            />
            {descError && (
              <img
                src={redAlertIcon}
                alt=""
                id="description-alert-icon"
                style={{
                  position: 'absolute',
                  right: 8,
                  bottom: 8,
                  width: 20,
                  height: 20,
                }}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
      {/* Footer */}
      <DialogActions sx={{ justifyContent: 'center', pb: 2, pl: 4, pr: 4 }}>
        <FielderButton id={'save-rating-btn'} size="medium" onClick={handleRateTask}>
          {props.lan.sendTicket}
        </FielderButton>
      </DialogActions>
    </Dialog>
  );
};
const mapStateToProps = (state) => ({
  user: state.utils.session.user,
});
export default connect(mapStateToProps)(RateTask);
